import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { letterheadAPI } from '../../services/api';
import { notify } from '../../utils/notify';
import { generateLetterheadPDF } from '../../utils/letterheadPDF';
import { useListControls, ListToolbar, Pagination } from '../../components/ListControls';
import Topbar from "../../components/Topbar";

function LetterheadHistory() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewing, setViewing] = useState(null);

  useEffect(() => {
    letterheadAPI.listRequests({ status: 'APPROVED', limit: 100 })
      .then(d => setRecords(d.requests || []))
      .catch(() => notify.error('Failed to load letterhead history'))
      .finally(() => setLoading(false));
  }, []);

  const lc = useListControls(records, {
    searchFields: ['requestId', r=>r.employeeName||r.requestedBy?.userName, r=>r.department||r.requestedBy?.department],
    dateField: 'updatedAt', pageSize: 10,
  });

  const downloadPDF = (r) => {
    generateLetterheadPDF({
      name: r.employeeName || r.requestedBy?.userName || '',
      designation: r.designation || '',
      department: r.department || r.requestedBy?.department || '',
      address: r.address || 'TSE Workspace Office, Green City, Sector-10, Lucknow - 226010',
      phone: r.phone || '+91 98765 43210',
      email: r.email || '',
      website: r.website || 'www.tseworkspace.com',
      refNo: r.refNo || r.requestId || 'TSE/LET/2025-26/XXX',
      date: r.updatedAt ? new Date(r.updatedAt).toLocaleDateString('en-IN') : new Date().toLocaleDateString('en-IN'),
      template: r.templateId?.name || 'Modern',
    });
    notify.success('PDF downloaded successfully');
  };

  const approvedBy = (r) => {
    const last = r.approvalHistory?.[r.approvalHistory.length - 1];
    return last?.approverId?.userName ? `${last.approverId.userName} (${last.level})` : 'HOD';
  };

  return (
    <>
      <Header />
      <div id="db-wrapper"><main id="page-content">
          <Topbar section="Letterhead" /><section className="container-fluid p-4 pt-3">
        <div className="page-hero d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="text-white lh-1">Letterhead History</h5>
            <div className="sub">View and download all approved letterheads as A4 PDF</div>
          </div>
          <div style={{background:'rgba(255,255,255,0.15)',borderRadius:10,padding:'4px 14px',color:'#fff',fontWeight:600,fontSize:'0.736rem'}}>
            <i className="bi bi-files me-2"/>{records.length} Total Approved
          </div>
        </div>

        <ListToolbar search={lc.search} setSearch={lc.setSearch} dateFrom={lc.dateFrom} setDateFrom={lc.setDateFrom} dateTo={lc.dateTo} setDateTo={lc.setDateTo} placeholder="Search by name, department, ID..." dateLabel="Approved"/>

        {loading
          ? <div className="text-center py-5"><span className="spinner-border text-primary" /></div>
          : lc.paginated.length === 0
            ? <div className="empty-state"><i className="bi bi-inbox" /><p>No approved letterheads found</p></div>
            : lc.paginated.map((r, idx) => (
              <div key={r._id} className="record-card">
                <div className="record-number">{(lc.page-1)*lc.pageSize+idx + 1}.</div>
                <div className="record-body">
                  <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                    <div style={{fontWeight:700,fontSize:'0.874rem',color:'#111827'}}>{r.employeeName || r.requestedBy?.userName}</div>
                    <span className="status-pill status-approved"><i className="bi bi-check-circle" />Approved</span>
                    {r.templateId && <span style={{background:'#f0fdf4',color:'#166534',fontSize:'0.7rem',fontWeight:600,padding:'2px 7px',borderRadius:20}}>{r.templateId.name} Template</span>}
                    <span style={{background:'#eff6ff',color:'#1d4ed8',fontSize:'0.7rem',fontWeight:600,padding:'2px 7px',borderRadius:20}}>
                      <i className="bi bi-file-earmark-pdf me-1"/>PDF Ready
                    </span>
                  </div>
                  <div className="row g-2">
                    <div className="col-12 col-md-5">
                      <div className="record-field"><span className="rf-label">Request ID — </span><span className="rf-value text-primary">{r.requestId}</span></div>
                      <div className="record-field"><span className="rf-label">Department — </span><span className="rf-value">{r.department || r.requestedBy?.department}</span></div>
                      <div className="record-field"><span className="rf-label">Designation — </span><span className="rf-value">{r.designation}</span></div>
                    </div>
                    <div className="col-12 col-md-5">
                      <div className="record-field"><span className="rf-label">Ref No. — </span><span className="rf-value">{r.refNo || r.requestId}</span></div>
                      <div className="record-field"><span className="rf-label">Approved On — </span><span className="rf-value">{new Date(r.updatedAt).toLocaleDateString('en-IN')}</span></div>
                      <div className="record-field"><span className="rf-label">Approved By — </span><span className="rf-value">{approvedBy(r)}</span></div>
                    </div>
                  </div>
                </div>
                <div className="divider d-none d-md-block" />
                <div className="record-actions">
                  <button className="btn-card-download" onClick={() => downloadPDF(r)}>
                    <i className="bi bi-file-earmark-pdf me-1"/>PDF
                  </button>
                  <div className="btn-divider" />
                  <button className="btn-card-view" onClick={() => setViewing(r)}>View</button>
                </div>
              </div>
            ))}

        <Pagination page={lc.page} totalPages={lc.totalPages} setPage={lc.setPage} totalCount={lc.totalCount} pageSize={lc.pageSize} itemLabel="records"/>

        {/* View Modal */}
        {viewing && (
          <div className="modal show d-block" style={{background:'rgba(0,0,0,0.55)'}}>
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content shadow-lg">
                <div className="modal-header border-0">
                  <h5 className="fw-bold"><i className="bi bi-file-earmark-text me-2"/>Preview — {viewing.refNo || viewing.requestId}</h5>
                  <button className="btn-close" onClick={() => setViewing(null)} />
                </div>
                <div className="modal-body p-4">
                  <div className="letterhead-preview">
                    <div className="letterhead-header-bar d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <div className="bg-white rounded-circle d-flex align-items-center justify-content-center" style={{width:32,height:32,background:'linear-gradient(135deg,#1a5276,#1e8449)'}}>
                          <i className="bi bi-tree-fill text-white fs-5"/>
                        </div>
                        <div>
                          <div className="fw-bold" style={{fontSize:'0.86rem'}}>TSE ENVIRONMENT</div>
                          <div style={{fontSize:'0.7rem',opacity:0.85}}>Official Letterhead</div>
                        </div>
                      </div>
                      <div style={{fontSize:'0.7rem',textAlign:'right'}}>
                        <div>Ref No.: {viewing.refNo || viewing.requestId}</div>
                        <div>Date: {new Date(viewing.updatedAt).toLocaleDateString('en-IN')}</div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <div style={{fontWeight:700,fontSize:'1.014rem',color:'#1a5276'}}>{viewing.employeeName || viewing.requestedBy?.userName}</div>
                        <div style={{color:'#555',fontSize:'0.81rem'}}>{viewing.designation}</div>
                        <div style={{color:'#888',fontSize:'0.754rem'}}>{viewing.department || viewing.requestedBy?.department} Department</div>
                        <div className="mt-2" style={{fontSize:'0.7rem',color:'#555',lineHeight:1.9}}>
                          <div><i className="bi bi-geo-alt-fill me-1 text-success"/>{viewing.address || 'TSE Workspace Office'}</div>
                          <div><i className="bi bi-telephone-fill me-1 text-success"/>{viewing.phone || '+91 98765 43210'}</div>
                          {viewing.email && <div><i className="bi bi-envelope-fill me-1 text-success"/>{viewing.email}</div>}
                          <div><i className="bi bi-globe me-1 text-success"/>{viewing.website || 'www.tseworkspace.com'}</div>
                        </div>
                      </div>
                      <div className="border rounded-2 d-flex flex-column align-items-center justify-content-center" style={{width:49,height:49,background:'#f8f9fa',border:'1.5px solid #1a5276'}}>
                        <i className="bi bi-qr-code" style={{fontSize:32,color:'#1a5276'}}/>
                        <div style={{fontSize:'0.46rem',color:'#6b7280',textAlign:'center'}}>Scan to verify</div>
                      </div>
                    </div>
                    <div style={{borderTop:'2px solid #1a5276',marginTop:8,paddingTop:6}}>
                      <div style={{border:'1.5px dashed #dee2e6',borderRadius:8,minHeight:80,display:'flex',alignItems:'center',justifyContent:'center',color:'#aaa',fontSize:'0.754rem',fontStyle:'italic'}}>
                        [ Official Letter Content Goes Here ]
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                      <div className="text-center">
                        <div style={{borderTop:'1.5px solid #333',width:130,marginBottom:4}}/>
                        <div style={{fontSize:'0.7rem',color:'#555'}}>Authorized Signatory</div>
                      </div>
                    </div>
                    <div className="letterhead-footer-bar mt-3 text-center" style={{fontSize:'0.598rem'}}>
                      TSE Workspace Office &bull; Green City, Sector-10, Lucknow - 226010 &bull; www.tseenvironment.com
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0 gap-2">
                  <button className="btn btn-light rounded-3 px-4" onClick={() => setViewing(null)}>Close</button>
                  <button className="btn btn-success rounded-3 px-5 fw-semibold" onClick={() => downloadPDF(viewing)}>
                    <i className="bi bi-file-earmark-pdf-fill me-2"/>Download PDF (A4)
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </section></main></div>
    </>
  );
}
export default LetterheadHistory;
